module.exports = __webpack_public_path__ + "img/29b761a49ec41c82ec9aff6ca4955260.png";